import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../_services';
import { Roles } from '../../_models';
import { Constants } from '../Constants';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    let roles: Roles[] = this.auth.roles;
    let path = state.url;
    let can_activate = false;
    let route_obj = Constants.getRoute(route.routeConfig?.path!);

    if (this.auth.isExpiredToken) {
      console.warn('Auth token is expired');
      this.auth.SignOut();
    }

    if (this.auth.isLoggedIn) {
      // logged in so return true
      return true;
    }

    // this.auth.SignOut();
    return false;
  }
}
